import { IBufferControllerConfig } from '@bufferController/BufferController.config';
import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { TEventBus } from '@eventBus/EventBus';
import { Fragment } from '@fragment/Fragment';

export class BufferChunksCache extends ConfigConsumer<IBufferControllerConfig> {
  private _cache: Fragment[] = [];
  private _lastMsn: number = -1;

  constructor(eventBus: TEventBus) {
    super('bufferController', eventBus);
  }

  public append(fragments: Fragment[]): void {
    for (const fragment of fragments) {
      if (!this._cache.length) {
        if (fragment.isInitSection) {
          this._cache = [fragment];
        }

        continue;
      }

      if (fragment.msn !== this._lastMsn) {
        const latestMSNToSave: number = fragment.msn - this.config.saveLastSegmentsCount + 1;
        this._cache = [...this._cache.filter((f) => f.isInitSection || f.msn >= latestMSNToSave), fragment];
      } else {
        this._cache.push(fragment);
      }

      this._lastMsn = fragment.msn;
    }
  }

  public getAll(): Fragment[] {
    return this._cache;
  }

  public reset(): void {
    this._cache = [];
    this._lastMsn = -1;
  }

  public destroy(): void {
    super.destroy();

    this._cache = [];
    this._lastMsn = -1;
  }
}
